import React, {useEffect, useRef, useState} from 'react';
import * as Icon from "react-feather";

const IconDropdownWithItems = ({
                                   ready = true,
                                   customClass = '',
                                   items,
                                   onSelect,
                                   icon = 'MoreHorizontal',
                                   iconSize
                               }) => {
    const IconComponent = Icon[icon];
    const [isOpen, setIsOpen] = useState(false);

    const dropdownRef = useRef();
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    });

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    const handleSelect = (item) => {
        onSelect(item);
        setIsOpen(false);
    };

    const DynamicIcon = ({iconName, size}) => {
        const IconComponent = Icon[iconName];
        return IconComponent ? <IconComponent size={size}/> : null;
    };

    if (!ready) {
        return <button
            className={`pointer-events-none sl-w-full sl-flex sl-justify-between sl-align-center sl-gap-2  sl-py-10 sl-px-10   `}
        >
            <IconComponent className={'sl-m-auto'} color={"#D0D5DD"} size={iconSize ? iconSize : 24}/>
        </button>
    }

    return (
        <div className="sl-flex sl-h-11" ref={dropdownRef}>
            <div className="select sl-w-full">
                <button
                    className={`${customClass} sl-cursor-pointer sl-w-full sl-flex sl-justify-between sl-align-center sl-gap-2 sl-bg-white sl-py-10 sl-px-10 sl-shadow-xs sl-border sl-border-solid sl-border-gray-300 sl-rounded-lg ${isOpen ? 'active' : ''}`}
                    onClick={handleToggle}
                >
                    <IconComponent className={'sl-m-auto'} size={iconSize ? iconSize : 24}/>
                </button>
                {isOpen && (
                    <div
                        className="select-options sl-flex sl-flex-col sl-w-55 sl-absolute sl-top-13 sl-right-0 sl-shadow-lg sl-bg-white sl-border sl-border-solid sl-border-gray-100 sl-rounded-lg">
                        {items.map((item, index) => (
                            <div
                                key={index}
                                rel={item.key}
                                className="sl-flex sl-align-center sl-justify-flex-start sl-gap-2 sl-text-gray-900 sl-py-10 sl-px-14"
                                onClick={() => handleSelect(item)}
                            >
                                <DynamicIcon iconName={item.icon} size={16}/>
                                {item.text}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default IconDropdownWithItems;
